﻿export function coverageCheckerSpecial() {
  if (document.querySelector(".coverage-checker-special") && localStorage.getItem("cookieAccept") !== null) {
    const main = document.querySelector(".coverage-checker-special");
    main.classList.add('show');
  }
}